import type { NavigateFunction } from 'react-router-dom'

/**
 * Navigate to a URL with support for cmd/ctrl+click to open in new tab
 * @param url - The URL to navigate to
 * @param navigate - The navigate function from useNavigate hook
 * @param event - Optional mouse event to check for cmd/ctrl key
 */
export function handleNavigation(url: string, navigate: NavigateFunction, event?: React.MouseEvent | MouseEvent) {
  // Check if cmd (Mac) or ctrl (Windows/Linux) is pressed
  const isNewTabRequested = event && (event.metaKey || event.ctrlKey)

  if (isNewTabRequested) {
    // Open in new tab
    window.open(url, '_blank')
  } else {
    // Navigate in same tab
    navigate(url)
  }
}

/**
 * Create a click handler that supports cmd/ctrl+click for new tabs
 * @param url - The URL to navigate to
 * @param navigate - The navigate function from useNavigate hook
 * @returns Click handler function
 */
export function createNavigationHandler(url: string, navigate: NavigateFunction): (event: React.MouseEvent) => void {
  return (event: React.MouseEvent) => {
    // Prevent default to avoid any conflicts
    event.preventDefault()
    event.stopPropagation()
    handleNavigation(url, navigate, event)
  }
}

/**
 * Handle AG-Grid row click with cmd/ctrl+click support
 * @param url - The URL to navigate to
 * @param navigate - The navigate function from useNavigate hook
 * @param event - The AG-Grid event object
 */
export function handleGridRowClick(
  url: string,
  navigate: NavigateFunction,
  event: any // AG-Grid event type
) {
  // AG-Grid provides the browser event in the event.event property
  const browserEvent = event.event as MouseEvent
  handleNavigation(url, navigate, browserEvent)
}
